import MooAgent from '../../../_assets/svg/agents/MooAgent.svg';
import { useLauncherStatus } from './launcher-status-store';
import { AVATAR_SIZE_REM } from '../components/agent-tile-size';
import { LAUNCHER_SHORTCUT_LABEL } from './launcher-shortcut';
import styles from './AskMooLauncherButton.module.css';

interface AskMooLauncherButtonProps {
  readonly onToggle: () => void;
}

/** The top-bar Ask Moo button: brand navy, pressed while the panel is open,
 *  a pulse while Moo is working on something, and the keyboard shortcut. */
export function AskMooLauncherButton({ onToggle }: AskMooLauncherButtonProps) {
  const { isOpen, runningCount } = useLauncherStatus();
  const working =
    runningCount === 1
      ? 'Moo is working on 1 task'
      : `Moo is working on ${runningCount} tasks`;

  return (
    <button
      type="button"
      className={styles.button}
      // Exactly the agent tile's height, so the button and the panel header's
      // avatar beside it line up.
      style={{ height: `${AVATAR_SIZE_REM.sm}rem` }}
      aria-pressed={isOpen}
      aria-keyshortcuts="Meta+J Control+J"
      title={`Ask Moo (${LAUNCHER_SHORTCUT_LABEL})`}
      onClick={onToggle}
    >
      <span className={styles.mark} aria-hidden>
        <MooAgent />
      </span>
      Ask Moo
      <span className={styles.shortcut} aria-hidden>
        {LAUNCHER_SHORTCUT_LABEL}
      </span>
      {runningCount > 0 && (
        <span className={styles.working} role="status" aria-label={working} />
      )}
    </button>
  );
}
